import { useEvaluationContext, useFeatureFlag } from '@platform/feature-flags';
import { setFeedbackEnabled } from '@platform/observability';
import { useEffect } from 'react';

// Anonymous users (no context.userId) never enable the widget, regardless of the rollout.
export function FeedbackFlagSync() {
  const [context] = useEvaluationContext();
  const feedbackEnabled = useFeatureFlag('sentry-user-feedback');

  useEffect(() => {
    setFeedbackEnabled(Boolean(context.userId) && feedbackEnabled);
  }, [context.userId, feedbackEnabled]);

  return null;
}
